import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Card, TextField } from '@material-ui/core';

export const Paragraph = styled.p`
  color: #617799;
  font-family: 'TTCommons';
  font-size: 17px;
  letter-spacing: 0;
  line-height: 21px;
  margin: 8px 0px 40px 0px;
`;

export const CardWrapper = styled(Card)`
  margin-bottom: 20px;
`;

export const ButtonBackToSignIn = styled.button`
  background: none;
  border: none;
  padding-left: 10%;
  color: #4c7cfd;
  font-family: 'TTCommons';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 11px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;

export const TextTitle = styled.p`
  color: #12253f;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  font-family: 'TTCommons';
`;

export const TextWrapper = styled(TextField)`
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 5px 5px rgba(60, 128, 209, 0.09);
`;

export const Header = styled.div`
  padding: 3% 0 1% 10%;
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const LinkWrapper = styled(Link)`
  text-decoration: none;
  font-family: 'TTCommons';
  margin: 15px auto;
  display: block;
  outline: none;
  text-align: center;
  color: #6e84a3;
  font-size: 17px;
  cursor: pointer;
  border-bottom: 2px solid #6e84a3;
  width: 100px;
  font-family: 'TTCommons';
  &:focus {
    color: #0066ff;
  }
`;
